import { z } from 'zod';

import { LocationIdSchema } from '@brightlocal/shared';

export const GBPACreateReportSettingsSchema = z.object({
  location_id: LocationIdSchema,
  schedule: z.string(),
  google_location: z.string(),
  search_terms: z.array(z.string())
});

export type GBPACreateReportSettings = z.infer<typeof GBPACreateReportSettingsSchema>;

export const GBPACreateReportResponseSchema = z
  .object({
    success: z.boolean(),
    'report-id': z.number()
  })
  .transform((data) => ({
    success: data.success,
    reportId: data['report-id']
  }));

export type GBPACreateReportResponse = z.infer<typeof GBPACreateReportResponseSchema>;

export const GBPARunReportResponseSchema = z.object({
  success: z.boolean(),
  errors: z.record(z.string(), z.string()).optional()
});

export type GBPARunReportResponse = z.infer<typeof GBPARunReportResponseSchema>;
